<template>
  <div class="dream" v-if="load">
    <div class="row banner" style="background: #000;">
      <div class="column small-12 medium-4 large-4">
        <div
          style="color: #fff;"
          class="left-text content-tile content-tile-subhead clearfix has-body has-cta content-tile-subhead content-tile-subhead-tall invert"
        >
          <h4>专业服务成就美好</h4>
          <h4>成为值得信赖的知名私募机构</h4>
          <h4>专注、开放、合作</h4>
          <h4>远见者稳进</h4>
          <h4>务实、专业、极致负责</h4>
        </div>
      </div>
      <div class="column small-12 medium-8 large-8 banner">
        <img style="width: 100%;" :src="banner.cover" alt />
      </div>
    </div>
    <div>
      <div class="paragraph paragraph--type--tile paragraph--view-mode--default">
        <div class="content-tile content-tile-billboard left clearfix">
          <div
            class="field field--name-field-tiles-media field--type-entity-reference field--label-hidden field__items"
          >
            <div class="field__item">
              <article class="view-mode-captionless-full-width media media-image">
                <div
                  class="field field--name-image field--type-image field--label-hidden field__item"
                >
                  <img
                    style="width: 100%"
                    sizes="100vw"
                    src="../assets/images/dream.png"
                    alt
                    typeof="foaf:Image"
                  />
                </div>
              </article>
            </div>
          </div>

          <div class="image-caption-box">
            <h2>
              <div
                class="field field--name-name field--type-string field--label-hidden field__item"
              >{{list[0].title}}</div>
            </h2>

            <div
              class="field field--name-field-tiles-body field--type-text-long field--label-hidden field__item"
            >
              <p>{{list[0].brief}}</p>
              <p>{{list[0].slogan}}</p>
            </div>

            <ul class="linklist">
              <li>
                <a href="/studyApply">马上申请学习实践机会</a>
              </li>
            </ul>
          </div>

          <div class="image-caption-box" style="float:right">
            <h2>
              <div
                class="field field--name-name field--type-string field--label-hidden field__item"
              >{{list[1].title}}</div>
            </h2>

            <div
              class="field field--name-field-tiles-body field--type-text-long field--label-hidden field__item"
            >
              <p>{{list[1].brief}}</p>
              <p>{{list[1].slogan}}</p>
            </div>

            <ul class="linklist">
              <li>
                <a href="/job">马上申请工作机会</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StudyAndWork from "@/components/home/studyAndWork.vue";
import { DreamInfo } from "@/api/index";
export default {
  components: {
    StudyAndWork,
  },
  data() {
    return {
      load: false,
      banner: null,
      list: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    DreamInfo((res) => {
      this.load = true;
      this.$emit("complete", true);
      if (res.code == 0) {
        this.banner = res.data.banner;
        this.list = res.data.list.list;
      }
    });
  },
  mounted() {
    document.getElementById("dream-top-action").classList.add("is-active");
  },
};
</script>
<style lang='less' scoped>
.dream {
  .row {
    margin: 0;
  }
  .column {
    padding-left: 0;
    padding-right: 0;
  }
  .small-squre {
    height: 20vw;
    img {
      height: 20vw;
    }
  }
}
@media print, screen and (min-width: 40em) {
  .content-tile-billboard {
    display: block;
  }
  h4 {
    font-size: 1.1rem;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .content-tile-billboard {
    display: block;
  }
  h4 {
    font-size: 1.5rem;
  }
}
@media screen and (min-width: 80em) {
  .content-tile-billboard {
    display: flex;
    justify-content: center;
  }
  h4 {
    font-size: 2rem;
  }
}
@media print, screen and (max-width: 40em) {
  .invert {
    height: auto !important;
    h4 {
      font-size: 1.3rem;
    }
  }
  .content-tile-billboard .media-image {
    max-height: 38vw;
    height: 38vw;
  
    img{
       height: 38vw;
       margin: 0;
    }
  }
  h2{
    font-size: 1.3rem;
  }
  .field__item{
    p{
      margin: 0;
    }
  }
  .image-caption-box{
    float: none!important;
  }
}
@media print, screen and (min-width: 120em) {
  .image-caption-box{
    min-height: 14vw;
  }
}

</style>